module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": '入力して検索'
    },
    domProps: {
      "value": _vm.input
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.click($event)
      },
      "input": function($event) {
        $event.preventDefault();
        _vm.updateValue($event.target.value)
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.enter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.up($event)
      }]
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openSuggestion),
      expression: "openSuggestion"
    }],
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "100%",
      "height": "300px",
      "overflow-y": "scroll"
    }
  }, _vm._l((_vm.matches), function(suggestion, index) {
    return _c('li', {
      class: {
        'active': _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          _vm.suggestionClick(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.suggestionDisplay(suggestion)))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49e21edc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/AutocompleteSelection.vue
// module id = 702
// module chunks = 0